import { LayoutDashboard, MousePointerClick, PenLine, GraduationCap } from 'lucide-react';
import { Reveal, Eyebrow } from './Reveal';

const FEATURES = [
  { icon: MousePointerClick, title: 'One-Click Lead Management', body: 'A clean private dashboard where you and your team view, sort and status every incoming customer request.' },
  { icon: PenLine, title: 'Safe Content & Price Updates', body: 'Update service menus, pricing and announcements with zero risk of breaking page layouts.' },
  { icon: GraduationCap, title: 'Zero Training Required', body: 'Straightforward buttons and tables — anyone on your team can run it on day one.' },
];

const LEADS = [
  ['M. Alvarez', 'Quote: Landscaping site', 'NEW', 'text-amber-300 border-amber-500/40'],
  ['J. Chen', 'Booking: Consultation', 'CONTACTED', 'text-sky-300 border-sky-500/40'],
  ['R. Patel', 'Quote: Bakery e-store', 'WON', 'text-emerald-300 border-emerald-500/40'],
];

export default function Portal() {
  return (
    <section id="portal" data-testid="portal-section" className="py-24 sm:py-32 bg-[#0B1528]/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <Reveal>
            <Eyebrow>Control & Simplicity</Eyebrow>
            <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl">
              A private owner portal, <span className="text-gradient-gold">included.</span>
            </h2>
            <p className="mt-5 text-slate-400 text-base leading-relaxed">
              Manage incoming leads and customers without ever touching code — and without breaking the site.
            </p>
          </Reveal>
          <div className="mt-10 space-y-7">
            {FEATURES.map((f, i) => (
              <Reveal key={f.title} i={i + 1}>
                <div className="flex gap-5">
                  <div className="shrink-0 h-11 w-11 rounded-xl border border-amber-500/25 bg-amber-500/5 flex items-center justify-center">
                    <f.icon size={19} className="text-amber-400" />
                  </div>
                  <div>
                    <h3 className="font-display font-semibold text-lg">{f.title}</h3>
                    <p className="text-sm text-slate-400 mt-1 leading-relaxed">{f.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal i={2}>
          <div className="gold-ring rounded-3xl bg-[#0F1C33]/80 p-8">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-2">
                <LayoutDashboard size={18} className="text-amber-400" />
                <span className="font-mono-tech text-xs tracking-[0.25em] text-slate-400 uppercase">Owner Portal — Preview</span>
              </div>
              <span className="h-2 w-2 rounded-full bg-emerald-400 animate-pulse" />
            </div>
            <div className="grid grid-cols-3 gap-3 mb-6">
              {[['27', 'LEADS / MO'], ['12', 'BOOKINGS'], ['$8.4k', 'PIPELINE']].map(([v, l]) => (
                <div key={l} className="border border-slate-800 rounded-xl bg-[#0B1528]/70 px-4 py-3">
                  <div className="font-display font-bold text-lg text-amber-300">{v}</div>
                  <div className="font-mono-tech text-[9px] tracking-[0.2em] text-slate-500">{l}</div>
                </div>
              ))}
            </div>
            <div className="space-y-2">
              {LEADS.map(([name, desc, status, cls]) => (
                <div key={name} className="flex items-center justify-between border border-slate-800 rounded-lg bg-[#0B1528]/70 px-4 py-3">
                  <div>
                    <div className="text-sm text-slate-200">{name}</div>
                    <div className="text-xs text-slate-500">{desc}</div>
                  </div>
                  <span className={`font-mono-tech text-[10px] tracking-widest border rounded-full px-3 py-1 ${cls}`}>{status}</span>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
